import { queryOptions } from '@tanstack/react-query';
import type { AttendanceNow, AttendancePeriod } from '@erp/shared';
import { api } from '@/lib/api-client';

/** Família da Supervisão (spec 071). */
export const SUPERVISION_KEY = ['erp', 'attendance'] as const;

/** [] ⇒ undefined (sem filtro): o api-client junta arrays com vírgula, o formato do intList */
const ids = (list: number[] | undefined) => (list && list.length > 0 ? list : undefined);

export function attendanceNowQuery(deskIds: number[] | undefined) {
  return queryOptions({
    queryKey: [...SUPERVISION_KEY, 'now', { desks: ids(deskIds) ?? null }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<AttendanceNow>('/attendance/now', {
        query: { desk_ids: ids(deskIds) },
        signal,
      });
      if (res.error) throw res.error;
      // a hora em que a resposta chegou, para contar o tempo a partir do relógio do servidor
      return { ...res.data, receivedAt: Date.now() };
    },
  });
}

export function attendancePeriodQuery(
  period: { start: string; end: string },
  deskIds: number[] | undefined
) {
  return queryOptions({
    queryKey: [...SUPERVISION_KEY, 'period', { ...period, desks: ids(deskIds) ?? null }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<AttendancePeriod>('/attendance/period', {
        query: { start: period.start, end: period.end, desk_ids: ids(deskIds) },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
